import { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { Sidebar } from '../../layouts/Sidebar';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import LandingBody from './LandingBody';

const LandingManage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: paramId } = useParams();
  const [form, setForm] = useState<any>({});
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);
  const [banners, setBanners] = useState<any>({});
  const [posts, setPosts] = useState<string[]>(['']);
  const [selectedBrands, setSelectedBrands] = useState<any>([]);
  const [productGroups, setProductGroups] = useState<any>([
    {
      title: '',
      products: []
    },
    {
      title: '',
      products: []
    },
    {
      title: '',
      products: []
    },
  ]);

  const send = async () => {
    dispatch(setLoading(true));

    const formData = new FormData();

    Object.entries(banners).map(([primaryKey, primaryValue]) => {
      Object.entries(primaryValue).map(([key, value]) => {
        formData.append(key, value);
      });
      formData.append('code', primaryKey);
    });

    const landing = await restApi(endpoints.landing.basic + (paramId || '')).post(form);

    const res = await Promise.all([
      restApi(endpoints.landing.productGroups + landing.data.id).put({ productGroups: productGroups }),
      restApi(endpoints.landing.brands + landing.data.id).put({ brands: selectedBrands }),
      restApi(endpoints.landing.posts + landing.data.id).put({ posts: posts }),
      restApi(endpoints.landing.banners + landing.data.id).upload(formData),
    ]);

    if (res[0].code == 200) {
      Swal.fire({
        title: 'موفق',
        text: `لندینگ با موفقیت ${paramId ? 'ویرایش' : 'ساخته'} شد`,
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          // navigate('/landing');
        }
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res[0]?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }

    dispatch(setLoading(false));
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await Promise.all([
      await restApi(endpoints.brand.index).get(),
      await restApi(endpoints.product.index).get(),
      paramId && await restApi(endpoints.landing.single + paramId).get()
    ]);

    setBrands(res[0].data);
    setProducts(res[1].data);

    if (paramId) {
      const newBanners = {};

      res[2].data.banners?.map(e => {
        newBanners[e.code] = {
          preview: e.media.url,
          mediaId: e.media.id,
          data: undefined,
          alt: e.title,
          link: e.link,
        };
      });

      setPosts(res[2].data?.posts?.map(e => process.env.REACT_APP_BLOG_URL + '/' + e.slug));

      setBanners(newBanners);

      setSelectedBrands(res[2].data.brands.map(e => e.id));

      setForm({
        title: res[2].data.title,
        description: res[2].data.description
      });

      setProductGroups(res[2].data.productGroups.map((e, index) => {
        return {
          title: e.title,
          products: e.products.map(e => e.id.toString())
        };
      }));
    }
    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <main className="dashboardBody">
        <Sidebar/>
        <div className="landingMain">
          <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
            {paramId ? 'ویرایش' : 'ثبت'} لندینگ
          </span>
            <span>
            <h1 className="sideBarTitle">بازگشت به صفحه لندینگ</h1>
             <h1 className="dashBoardTitle">{paramId ? `ویرایش لندینگ ${form.title}` : 'افزودن لندینگ جدید'}</h1>
          </span>
            <i className="backAdd clickable" onClick={() => navigate('/landing/')}></i>
          </div>
        </div>
        <LandingBody brands={brands} productGroups={productGroups} products={products} banners={banners} selectedBrands={selectedBrands} setSelectedBrands={setSelectedBrands} setProductGroups={setProductGroups} setBanners={setBanners} form={form} setForm={setForm} posts={posts} setPosts={setPosts}/>
      </main>
    </>
  );
};
export default LandingManage;